module.exports = __webpack_public_path__ + "static/header-c9ab1799a8f322adb1d066e27834f1f7.jpg";